<mh-alerts-wrapper>
  <section mhFilterBar>
    <div mhFilterGroup>
      <div>
        <mh-core-lib-datepicker
            [currentDates]="currentDates"
            [currentFilter]="currentFilterDate"
            (datepickerUpdated)="handleDatepickerUpdated($event)">
        </mh-core-lib-datepicker>
      </div>
      <mh-box-element *ngIf="fidelityPermisions.includes('interchain_followup_properties_result')">
        <mh-core-lib-filter-chain-zone [productId]="productId" [multipleSelectionMode]="true" (chainChanged)="setChain($event)"></mh-core-lib-filter-chain-zone>
      </mh-box-element>
      <mh-core-lib-filter-hotels [chainFilter]="originalChainFilter" [multipleSelectionMode]="true" (hotelsChanged)="setHotelsFilter($event)"></mh-core-lib-filter-hotels>  
      <mh-core-lib-survey-wrapper *ngIf="chainFilter.length > 0" [productId]="productId" [chain]="chainFilter" [listenCustomerSubscribe]="false" [multipleSelectionMode]="true"
        (currentSurveySetted)="onSurveysLoaded()"
        #surveyWrapper></mh-core-lib-survey-wrapper>
    </div>

    <div>
      <mh-filter-date
          [startDate]="startDate"
          [endDate]="endDate"
          [report]="fidelityPermisions.includes('interchain_followup_properties_report') ? report : null"
          [reportActiveEmail]="true"
          [chain]="chainToReport"
          [checkPermissions]="true"
          [slug]="reportSlug"
          [productId]="productId">
      </mh-filter-date>
    </div>
  </section>
  <ng-container *ngIf="!waiting">
    <mh-box-element *ngIf="fidelityPermisions.includes('interchain_followup_properties_result')">
      <div class="tw-bg-white tw-h-[100%] tw-p-5 tw-rounded-lg tw-shadow-b-md tw-shadow-md tw-shadow-t-md tw-shadow-tb">
        <mh-followup-properties [currentDates]="currentDates" [chain]="chainFilter" [productId]="productId" [headerKeys]="headerTable" (isReady)="dataIsReady($event)" (filteredChain)="setChainToReport($event)"></mh-followup-properties>
      </div>
    </mh-box-element>
  </ng-container>

</mh-alerts-wrapper>
